import styled from 'styled-components';
import { PerfectSkeleton } from '../../../../../components/Common/perfect-skeleton/perfect-skeleton.component';
import { THEME } from '../../../../../themes';
import {
  PositionCardContainer,
  HeaderContainer,
  BodyContainer,
  FooterContainer,
  Divider,
} from '../position-card.styled';

const HeaderLeft = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${THEME.SPACING.TINY};
`;

const UserPickersContainer = styled.div`
  display: flex;
  gap: ${THEME.SPACING.LOOSE};
  align-items: flex-end;
`;

const UserPickerSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${THEME.SPACING.MICRO};
  min-width: 108px;
`;

const PositionCardSkeleton = (): JSX.Element => {
  return (
    <PositionCardContainer isPositionClosed={ false }>
      <HeaderContainer>
        <HeaderLeft>
          <PerfectSkeleton width={ 280 } height={ 24 } />
          <PerfectSkeleton width={ 200 } height={ 16 } />
        </HeaderLeft>
        <PerfectSkeleton width={ 30 } height={ 30 } variant="circular" />
      </HeaderContainer>

      <BodyContainer>
        <PerfectSkeleton width={ 168 } height={ 96 } variant="rounded" />
        <PerfectSkeleton width={ 168 } height={ 96 } variant="rounded" />
        <PerfectSkeleton width={ 168 } height={ 96 } variant="rounded" />
      </BodyContainer>

      <Divider />

      <FooterContainer>
        <UserPickersContainer>
          <UserPickerSection>
            <PerfectSkeleton width={ 60 } height={ 12 } />
            <PerfectSkeleton width={ 40 } height={ 40 } variant="circular" />
          </UserPickerSection>
          <UserPickerSection>
            <PerfectSkeleton width={ 90 } height={ 12 } />
            <PerfectSkeleton width={ 40 } height={ 40 } variant="circular" />
          </UserPickerSection>
        </UserPickersContainer>
        <PerfectSkeleton width={ 120 } height={ 20 } />
      </FooterContainer>
    </PositionCardContainer>
  );
};

export default PositionCardSkeleton;
